<div class="grid-view-main-container">
  <div class="table-container">
    <table class="table">
      <thead class="thead-dark sticky-top">
        <tr>
          <th class="column-selector-container" *ngIf="showColumnSelector">
            <div (click)="openColumnOptions($event)">
              <ion-icon name="caret-down-circle-outline" class="table-header-select ion-no-padding"></ion-icon>
            </div>
          </th>
          <th class="column-selector-container px-0 ps-1" *ngIf="multiSelectProperty">
            <div class="px-0">
              <input
                type="checkbox"
                class="align-middle"
                [checked]="isAllSelected()"
                (change)="toggleSelectAllRows($event)"
              >
            </div>
          </th>

          <th style="width: 80px;" *ngIf="shouldShowColumn('itineraryId')">
            <div class="table-heading">
               <p class="text mb-0">Quote ID</p>
            </div>
          </th>
          <th *ngIf="shouldShowColumn('leadId')">
            <div class="table-heading">
              <p class="text mb-0">Lead ID</p>
            </div>
          </th>
          <th class="phone-number-column" *ngIf="shouldShowColumn('leadName')">
            <div class="table-heading">
              <p class="text mb-0">Name</p>
            </div>
          </th>
          <th class="destination-list-column" *ngIf="shouldShowColumn('destination')">
            <div class="table-heading">
              <p class="text mb-0">Destination</p>
            </div>
          </th>
          <th class="no-of-days-column" *ngIf="shouldShowColumn('totalDays')">
            <div class="table-heading">
              <p class="text mb-0">Nights</p>
            </div>
          </th>
          <th class="phone-number-column" *ngIf="shouldShowColumn('travelDate')">
            <div class="table-heading">
              <p class="text mb-0">Travel Date</p>
            </div>
          </th>
          <th *ngIf="shouldShowColumn('totalAdults')">
            <div class="table-heading">
              <p class="text mb-0">Travelers</p>
            </div>
          </th>
          <th *ngIf="shouldShowColumn('tourPackageAmount')">
            <div class="table-heading" >
              <p class="text mb-0">Amount</p>
            </div>
          </th>
          <th *ngIf="shouldShowColumn('status')">
            <div class="table-heading" >
              <p class="text mb-0">Status</p>
            </div>
          </th>
          <th *ngIf="shouldShowColumn('createdBy')">
            <div class="table-heading" >
              <p class="text mb-0">Created By</p>
            </div>
          </th>
          <th *ngIf="shouldShowColumn('createDate')">
            <div class="table-heading" >
              <p class="text mb-0">Created Date</p>
            </div>
          </th>
          <th class="options-column">
            <div class="table-heading border-0">
              <p class="text mb-0">Options</p>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let key of dataKeys">
          <tr>
            <td class="px-0">
              <ion-button 
                class="show-childs-btn" 
                *ngIf="data[key]?.length > 1" 
                (click)="toggleRow(key)">
                <ion-icon [name]="expandedRows[key] ? 'caret-down-outline' : 'caret-forward-outline'"></ion-icon>
              </ion-button>
            </td>
            <td *ngIf="multiSelectProperty" class="px-0">
              <div class="px-0 ps-1">
                <input
                  type="checkbox"
                  class="align-middle"
                  [checked]="isRowSelected(data[key][0])"
                  (change)="toggleSelectRow($event, data[key][0])"
                >
              </div>
            </td>
            <td *ngIf="shouldShowColumn('itineraryId')" (click)="onCellClicked(data[key][0], 'itineraryId')"><span class="clickable-text">{{data[key][0].itineraryId}}</span></td>
            <td *ngIf="shouldShowColumn('leadId')" (click)="onCellClicked(data[key][0], 'leadId')"><span class="clickable-text">{{data[key][0].leadId}}</span></td>
            <td *ngIf="shouldShowColumn('leadName')">{{data[key][0].leadName}}</td>
            <td *ngIf="shouldShowColumn('destination')" style="max-width: 300px; text-overflow: ellipsis; overflow: hidden;"><span *ngFor="let dest of data[key][0].destination; index as i">{{dest.location.split(',')[0] + "("+ dest.days +")"}}<span *ngIf="i+1 !== data[key][0].destination.length">, </span></span></td>
            <td *ngIf="shouldShowColumn('totalDays')">{{data[key][0].totalDays}}</td>
            <td *ngIf="shouldShowColumn('travelDate')">{{data[key][0].travelDate | date}}</td>
            <td *ngIf="shouldShowColumn('totalAdults')">A{{data[key][0].totalAdults}} | C{{data[key][0].totalChildrens}} | I{{data[key][0].totalInfants}}</td>            

            <!-- Total amount of quote shown on conditinal base -->
            <ng-container *ngIf="shouldShowColumn('tourPackageAmount')">
              <td *ngIf="data[key][0].tourPackageAmount && data[key][0].tourPackageAmount !== 0 else showLandPackageCost">{{data[key][0].tourPackageAmount  | currency: 'INR'}}</td>
              <ng-template #showLandPackageCost>
                <td >
                  <div *ngIf="data[key][0].landPackageAmount?.length" class="package-cost-container">
                    {{data[key][0].landPackageAmount[0].packageIncludingAirfare | currency: 'INR'}} <span class="clickable-text" *ngIf="data[key][0].landPackageAmount?.length > 1">+{{data[key][0].landPackageAmount?.length - 1}}</span>

                    <!-- Popover -->
                     <div class="popover-container">
                        <div>
                          <div class="single-package" *ngFor="let landPackage of data[key][0].landPackageAmount; index as i">
                            <div class="d-flex justify-content-between">
                              <p class="title">Package {{i+1}}</p>
                              <p class="title">{{landPackage.packageIncludingAirfare | currency: 'INR'}} </p>
                            </div>  
                            <div *ngIf="landPackage.landPackageNote?.length">
                              <ul class="hotels-list">
                                <li *ngFor="let hotel of landPackage.landPackageNote">{{hotel}}</li>
                              </ul>
                            </div>
                            
                          </div>
                        </div>
                     </div>
                  </div>
                  <span *ngIf="!data[key][0].landPackageAmount?.length">--</span>
                </td>
              </ng-template>
              
            </ng-container>


            <td *ngIf="shouldShowColumn('status')">{{data[key][0].status}}</td>
            <td *ngIf="shouldShowColumn('createdBy')">{{data[key][0].createdBy}}</td>
            <td *ngIf="shouldShowColumn('createDate')">{{data[key][0].createDate | date: 'MMM d, yyyy - h:mm a'}}</td>
            <td>
              <div class="options" (click)="showOptions($event, data[key][0])">  
                <ion-icon name="ellipsis-horizontal-outline"></ion-icon>
              </div>
            </td>
          </tr>
          <!-- Additional rows for child itineraries -->
          <tr class="children-row" *ngFor="let item of data[key]; let i = index" [ngClass]="{ 'd-none': !expandedRows[key] || i === 0 }">
            <td></td>
            <td *ngIf="multiSelectProperty" class="px-0">
              <div class="px-0 ps-1">
                <input
                  type="checkbox"
                  class="align-middle"
                  [checked]="isRowSelected(item)"
                  (change)="toggleSelectRow($event, item)"
                >
              </div>
            </td>
            <td *ngIf="shouldShowColumn('itineraryId')" (click)="onCellClicked(data[key][0], 'itineraryId')"><span class="clickable-text">{{item.itineraryId}}</span></td>
            <td *ngIf="shouldShowColumn('leadId')" (click)="onCellClicked(data[key][0], 'leadId')"><span class="clickable-text">{{item.leadId}}</span></td>
            <td *ngIf="shouldShowColumn('leadName')">{{item.leadName}}</td>
            <td *ngIf="shouldShowColumn('destination')" style="max-width: 300px; text-overflow: ellipsis; overflow: hidden;"><span *ngFor="let dest of data[key][0].destination; index as i">{{dest.location.split(',')[0] + "("+ dest.days +")"}}<span *ngIf="i+1 !== data[key][0].destination.length">, </span></span></td>
            <td *ngIf="shouldShowColumn('totalDays')">{{item.totalDays}}</td>
            <td *ngIf="shouldShowColumn('travelDate')">{{item.travelDate | date}}</td>
            <td *ngIf="shouldShowColumn('totalAdults')">A{{item.totalAdults}} | C{{item.totalChildrens}} | I{{item.totalInfants}}</td>
            
            <!-- Total amount of quote shown on conditinal base -->
            <ng-container *ngIf="shouldShowColumn('tourPackageAmount')">
              <td *ngIf="item.tourPackageAmount && item.tourPackageAmount !== 0 else showLandPackageCost">{{item.tourPackageAmount  | currency: 'INR'}}</td>
              <ng-template #showLandPackageCost>
                <td >
                  <div *ngIf="item.landPackageAmount?.length" class="package-cost-container">
                    {{item.landPackageAmount[0].packageIncludingAirfare | currency: 'INR'}} <span class="clickable-text" *ngIf="item.landPackageAmount?.length > 1">+{{item.landPackageAmount?.length - 1}}</span>

                    <!-- Popover -->
                     <div class="popover-container">
                        <div>
                          <div class="single-package" *ngFor="let landPackage of item.landPackageAmount; index as i">
                            <div class="d-flex justify-content-between">
                              <p class="title">Package {{i+1}}</p>
                              <p class="title">{{landPackage.packageIncludingAirfare | currency: 'INR'}} </p>
                            </div>  
                            <div *ngIf="landPackage.landPackageNote?.length">
                              <ul class="hotels-list">
                                <li *ngFor="let hotel of landPackage.landPackageNote">{{hotel}}</li>
                              </ul>
                            </div>
                            
                          </div>
                        </div>
                     </div>
                  </div>
                  <span *ngIf="!item.landPackageAmount?.length">--</span>
                </td>
              </ng-template>
              
            </ng-container>

            <td *ngIf="shouldShowColumn('status')">{{item.status}}</td>
            <td *ngIf="shouldShowColumn('createdBy')">{{item.createdBy}}</td>
            <td *ngIf="shouldShowColumn('createDate')">{{item.createDate | date: 'MMM d, yyyy - h:mm a'}}</td>
            <td>
              <div class="options" (click)="showOptions($event, item)">  
                <ion-icon name="ellipsis-horizontal-outline"></ion-icon>
              </div>
            </td>
          </tr>
        </ng-container>
  
        <tr *ngIf="dataKeys.length === 0">
          <td [attr.colspan]="getfullColSpan()" class="text-center py-3">No Results Found</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="w-100 paginations-container" *ngIf="!hidePaginations">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center">
        <div class="select-container">
          <select name="" id="" class="records-selector" [(ngModel)]="paginationSettings.pageSize" (change)="onPageSizeChange()">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>
        <div class="label-container">
          <p class="label">Showing {{noOfRows}} records of {{paginationSettings.totalCount}}</p>
        </div>
      </div>
  
      <div class="control-btns">
        <div class="buttons-row">
          <!-- Back btn -->
          <ion-button class="control-btn" (click)="onPrevious()" [disabled]="paginationSettings.pageNumber === 1">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-button>
  
          <!-- pages buttons list -->
          <ion-button 
            class="control-btn" 
            *ngFor="let page of visiblePages" 
            (click)="onPageChange(page)" 
            [class.active]="page === paginationSettings.pageNumber">
            {{page}}
          </ion-button>
  
          <!-- Forward btn -->
          <ion-button class="control-btn" (click)="onNext()" [disabled]="paginationSettings.pageNumber === paginationSettings.totalPages">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
  </div>

</div>
